import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    dialogId: String,
  }

  DIALOG_OPEN_CLASS = 'components--modal__dialog--open'
  DIALOG_CONTROLLER = 'ui--modal--dialog'

  connect() {
    const bodyDialog = document.querySelector(`body > dialog#${this.dialogIdValue}`)
    const innerDialog = this.element.querySelector(`dialog#${this.dialogIdValue}`)

    if (bodyDialog != null && bodyDialog.getAttribute('open') != null) {
      // allow controller to reattach to an existing *open* dialog if it is (for example)
      // replaced by a turbo stream or frame
      this.dialog = bodyDialog
      this.element.removeChild(innerDialog)
    } else if (bodyDialog != null && innerDialog == null) {
      // if there is no inner dialog, just attach to the body dialog
      this.dialog = bodyDialog
    } else if (innerDialog != null) {
      // otherwise, replace the dialog with the new one
      this.dialog = innerDialog
      this.element.removeChild(innerDialog)
      innerDialog.setAttribute('data-controller', this.DIALOG_CONTROLLER)
      document.body.append(innerDialog)
      if (bodyDialog) document.body.removeChild(bodyDialog)
    }

    if (this.dialog == null) {
      throw new Error('Missing dialog in modal controller!')
    }

    this.element.addEventListener('modal:open', this.handleOpen)
    addEventListener('turbo:before-cache', this.handleBeforeCache)
  }

  disconnect() {
    removeEventListener('turbo:before-cache', this.handleBeforeCache)
    this.element.removeEventListener('modal:open', this.handleOpen)
  }

  handleOpen = () => {
    // Ensure dialog is in the document before attempting to show it
    // This handles edge cases where turbo-frame replacement may have
    // invalidated the dialog reference
    if (!document.contains(this.dialog)) {
      // Try to find the dialog in body first
      let dialog = document.querySelector(`body > dialog#${this.dialogIdValue}`)
      if (!dialog) {
        // Try to find it inside the element (may not have been moved yet)
        dialog = this.element.querySelector(`dialog#${this.dialogIdValue}`)
        if (dialog) {
          // Move it to body
          this.element.removeChild(dialog)
          dialog.setAttribute('data-controller', this.DIALOG_CONTROLLER)
          document.body.append(dialog)
        }
      }
      if (dialog) {
        this.dialog = dialog
      } else {
        console.error('Modal dialog not found:', this.dialogIdValue)
        return
      }
    }

    this.dialog.hidden = false
    requestAnimationFrame(() => {
      // Double-check dialog is still in the document (race condition protection)
      if (!document.contains(this.dialog)) {
        console.warn('Modal dialog removed from document before showModal:', this.dialogIdValue)
        return
      }
      this.dialog.classList.add(this.DIALOG_OPEN_CLASS)
      this.dialog.showModal()
    })
  }

  handleBeforeCache = () => {
    // restore initial state, with dialog contained within element
    // connect remains idempotent in case this does not run for whatever reason
    if (document.body.contains(this.dialog)) {
      document.body.removeChild(this.dialog)
      this.dialog.removeAttribute('data-controller')
      this.dialog.removeAttribute('open')
      this.dialog.classList.remove(this.DIALOG_OPEN_CLASS)
      this.element.appendChild(this.dialog)
    }
  }
}
